import React from 'react';
import { Card } from 'react-bootstrap';
import { FiActivity } from 'react-icons/fi';
import { formatTimeAgo } from '@core/utils/formatTimeAgo';
import type { DashboardRecentActivity } from '../types/dashboard';

interface Props {
  items: DashboardRecentActivity[];
}

const RecentActivityFeed: React.FC<Props> = ({ items }) => {
  if (!items.length) return null;

  return (
    <Card className="ntcog-card dashboard-section-card mb-4">
      <Card.Header>Recent Activity</Card.Header>
      <Card.Body>
        <div className="dashboard-list">
          {items.map((item) => (
            <div key={item.activity_id} className="dashboard-list-item">
              <div className="d-flex align-items-center gap-3 min-w-0">
                <div className="dashboard-avatar">
                  <FiActivity size={16} />
                </div>
                <div className="min-w-0">
                  <div className="fw-medium text-truncate">{item.display_name}</div>
                  <small className="text-muted text-truncate d-block">{item.description}</small>
                </div>
              </div>
              <small className="text-muted flex-shrink-0">{formatTimeAgo(item.occurred_at)}</small>
            </div>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
};

export default RecentActivityFeed;
